<app-breadcrumb [title]="'404'" [breadcrumb]="'404'"></app-breadcrumb>
<!-- section start -->
<section class="p-0">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="error-section">
                    <h1>404</h1>
                    <h2>PÁGINA NÃO ENCONTRADA</h2>
                    <a [routerLink]="'/pages/login'" class="btn btn-solid">Voltar pra tela inicial</a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->